import Footer from "@/components/Footer";
import { Link } from "react-router-dom";

const CASES = [
  {
    title: "Notte Barocca — Lecce",
    year: 2024,
    tag: "Piazza · Estate",
    audience: "12.400 spettatori",
    photo: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt: "Tre palchi in centro storico, sette compagnie, illuminazione architetturale sui monumenti barocchi.",
  },
  {
    title: "Gala Confindustria — Milano",
    year: 2024,
    tag: "Corporate · Gala",
    audience: "800 ospiti",
    photo: "https://images.unsplash.com/photo-1511578314322-379afb476865?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt: "Rivista teatrale con orchestra live, chef stellato e speech aziendale in un teatro storico.",
  },
  {
    title: "Villa D'Este Wedding — Como",
    year: 2023,
    tag: "Matrimonio · Luxury",
    audience: "220 invitati",
    photo: "https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt: "String quartet all'arrivo, band swing durante la cena, DJ set fino all'alba affacciati sul lago.",
  },
  {
    title: "San Gennaro Fest — Napoli",
    year: 2023,
    tag: "Patronale · Piazza",
    audience: "30.000 persone",
    photo: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt: "Concertone finale con headliner nazionale, service audio in Line Array e pirotecnica fredda.",
  },
  {
    title: "Cerimonia Laurea Bocconi",
    year: 2024,
    tag: "Università · Cerimonia",
    audience: "1.200 laureati",
    photo: "https://images.unsplash.com/photo-1523580494863-6f3031224c94?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt: "Coro d'archi, ospite comico, coreografia finale con lancio dei cappelli sincronizzato.",
  },
  {
    title: "Casting Sanremo — Roma",
    year: 2024,
    tag: "TV · Casting",
    audience: "230 candidati",
    photo: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt: "Provini video 4K, coordinamento agenti, scouting per la finale nazionale della kermesse.",
  },
  {
    title: "Circo Sotto le Stelle — Torino",
    year: 2023,
    tag: "Festival · Circo",
    audience: "8.500 spettatori",
    photo: "https://images.pexels.com/photos/37071005/pexels-photo-37071005.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
    excerpt: "Tre giorni di circo contemporaneo con compagnie italiane, francesi e spagnole in un ex quartiere industriale.",
  },
  {
    title: "Convention Tech — Milano",
    year: 2024,
    tag: "Corporate · Convention",
    audience: "1.600 delegati",
    photo: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt: "Keynote con talent internazionale, dj set live in apertura, mapping video su fondale 24 metri.",
  },
];

export default function Portfolio() {
  return (
    <div className="pt-28 pb-16">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="av-eyebrow">Portfolio eventi</span>
        <h1 className="font-serif-display text-4xl sm:text-6xl mt-3 leading-tight">
          Otto storie. Un solo <span className="italic text-[#E5A93C]">interlocutore</span>.
        </h1>
        <p className="text-[#F7F4EE]/80 max-w-2xl mt-6 leading-relaxed">
          Piazze, teatri storici, gala aziendali, cerimonie universitarie e casting TV:
          ecco alcuni degli eventi che abbiamo prodotto negli ultimi due anni. Ogni
          progetto ha una storia — la tua sarà la prossima.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14" data-testid="case-studies">
          {CASES.map((c, i) => (
            <article
              key={c.title}
              className="av-card overflow-hidden group"
              data-testid={`case-${i}`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={c.photo}
                  alt={c.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <span className="av-eyebrow text-[10px]">{c.tag}</span>
                  <span className="text-xs text-[#A39E93]">{c.year}</span>
                </div>
                <h3 className="font-serif-display text-2xl mt-2">{c.title}</h3>
                <p className="text-xs text-[#E5A93C] font-mono mt-1">{c.audience}</p>
                <p className="text-sm text-[#F7F4EE]/70 mt-3 leading-relaxed">{c.excerpt}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="av-card p-8 mt-16 text-center">
          <div className="av-eyebrow">La prossima storia è la tua</div>
          <h3 className="font-serif-display text-3xl mt-2">
            Raccontaci il tuo <span className="italic text-[#E5A93C]">evento</span>
          </h3>
          <Link to="/richiedi" className="av-pill av-pill-gold mt-6 inline-flex" data-testid="portfolio-cta">
            Parla con NMA
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
